module.exports = __webpack_public_path__ + "static/media/Jcb.a86c6701.svg";